import * as React from 'react';
import * as Styles from './CurrentLocationButton.scss';

interface IOwnProps {
  isVisible: boolean;
  isLoading: boolean;
  label: string;
  loadingLabel: string;
  denitedLabel: string;
  isDenited: boolean;
  onClick: () => void;
}

const CurrentLocationButton: React.SFC<IOwnProps> = ({ isVisible, isLoading, label, loadingLabel, denitedLabel, isDenited, onClick }) => {
  if (!isVisible) { return null; }

  return (
    <div className={Styles.wrapper} onClick={onClick}>
      <span className={Styles.label}>
        {!isDenited && !isLoading && label}
        {!isDenited && isLoading && loadingLabel}
        {isDenited && denitedLabel}
      </span>
    </div>
  );
};

export default CurrentLocationButton;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/presentational/CurrentLocationButton/CurrentLocationButton.tsx